import React from "react";
import { useRecoilState } from "recoil";
import { useState, useEffect, useRef } from "react";
import { wishlistAtom } from "../../store/atoms";
import SocialShareButton from "../moments/SocialShareButton";
import { useIsMobile } from '../../customHook/useIsMobile';
import {
  fetchUserAttributes,
  getCurrentUser,
  resendSignUpCode,
} from "aws-amplify/auth";

const HeartIcon = ({ section, card }) => {
  const [wishlist, setWishlist] = useRecoilState(wishlistAtom);
  const isSelected = wishlist[section]?.some((c) => c.title === card.title);

  const handleClick = (e) => {
    e.stopPropagation();
    setWishlist((prev) => {
      const existing = prev[section] || [];
      return {
        ...prev,
        [section]: existing.filter((c) => c.title !== card.title),
      };
    });
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: "absolute",
        top: "16px",
        right: "16px",
        width: "16px",
        height: "16px",
        cursor: "pointer",
        zIndex: 2,
      }}
    >
      {isSelected ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 13"
          fill="#FFF"
        >
          <path
            d="M6.94307 11.645C5.06222 10.2385 1.33594 7.02304 1.33594 4.12946C1.33594 2.21692 2.73944 0.666504 4.66927 0.666504C5.66927 0.666504 6.66927 0.999837 8.0026 2.33317C9.33594 0.999837 10.3359 0.666504 11.3359 0.666504C13.2657 0.666504 14.6693 2.21692 14.6693 4.12946C14.6693 7.02304 10.943 10.2385 9.06214 11.645C8.4292 12.1182 7.576 12.1182 6.94307 11.645Z"
            stroke="#FFF"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 13"
          fill="none"
        >
          <path
            d="M6.94307 11.645C5.06222 10.2385 1.33594 7.02304 1.33594 4.12946C1.33594 2.21692 2.73944 0.666504 4.66927 0.666504C5.66927 0.666504 6.66927 0.999837 8.0026 2.33317C9.33594 0.999837 10.3359 0.666504 11.3359 0.666504C13.2657 0.666504 14.6693 2.21692 14.6693 4.12946C14.6693 7.02304 10.943 10.2385 9.06214 11.645C8.4292 12.1182 7.576 12.1182 6.94307 11.645Z"
            stroke="#F5F3ED"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
  );
};

const handleViewList = (occasion) => {
  console.log(`Viewing list for: ${occasion}`);
};

const handleShareList = (occasion) => {
  console.log(`Sharing list for: ${occasion}`);
};

const Wishlist = ({ isOpen, userName }) => {
  const [wishlistData] = useRecoilState(wishlistAtom);
  const [userAttributes, setUserAttributes] = useState({});
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const isMobile =  useIsMobile() ;

  // NEW STATE FOR ADD EXTERNAL LINKS
  const [showLinkInput, setShowLinkInput] = useState(false);
  const [linkInput, setLinkInput] = useState("");
  const [addedLinks, setAddedLinks] = useState([]);
  
  // Ref for the right side items container
  const itemsContainerRef = useRef(null);
  
  // Define URL patterns for specific products
  const urlPatterns = [
    {
      pattern: /amazon\.com.*B0CYH9B859|phone.*case.*suction/i,
      card: "Silicone Suction Cup Phone Mount",
      link: "https://www.amazon.com/dp/B0CYH9B859?th=1"
    },
    {
      pattern: /urbanoutfitters\.com.*ugg|ugg.*women.*boot|boot.*urban/i,
      card: "UGG Ultra Mini Platform Boot",
      link: "https://www.urbanoutfitters.com/shop/hybrid/ugg-womens-classic-ultra-mini-platform-boot"
    },
    {
      pattern: /bose\.com.*quietcomfort|quietcomfort.*headphones|headphones.*bose/i,
      card: "Bose Quiet Comfort Headphones",
      link: "https://www.bose.com/p/headphones/quietcomfort-acoustic-noise-cancelling-headphones/QC-HEADPHONEARN.html?dwvar_QC-HEADPHONEARN_color=PETAL+PINK&quantity=1"
    }
  ];

  // Define available cards with their associated links
  const initialAvailableCards = [
    {
      title: "Bose Quiet Comfort Headphones",
      subtitle: "Noise cancellation with 24-hour battery life.",
      image: "./blueheadphones.png",
      price: "$179.00",
      link: "https://www.bose.com/p/headphones/quietcomfort-acoustic-noise-cancelling-headphones/QC-HEADPHONEARN.html?dwvar_QC-HEADPHONEARN_color=PETAL+PINK&quantity=1",
      id: "headphones"
    },
    {
      title: "UGG Ultra Mini Platform Boot",
      subtitle: "Short silhouette for a classic, go-to look.",
      image: "./boot.png",
      price: "$169.95",
      link: "https://www.urbanoutfitters.com/shop/hybrid/ugg-womens-classic-ultra-mini-platform-boot",
      id: "boots"
    },
    {
      title: "Silicone Suction Cup iPhone Mount",
      subtitle: "Attach your phone for a hands-free experience.",
      image: "./iphone.png",
      price: "$7.99",
      link: "https://www.amazon.com/dp/B0CYH9B859?th=1",
      id: "phone"
    }
  ];

  const [availableCards, setAvailableCards] = useState([...initialAvailableCards]);

  const staticWishlistItems = [
    {
      title: "Float into Birthday Fun",
      subtitle: "A cheerful celebration set with balloons and treats.",
      image: "./bdayfun.svg",
      price: "$49.99",
    },
    {
      title: "Fresh Flowers Upgrade",
      subtitle: "A beautiful bouquet for any special day.",
      image: "./flowerscare.svg",
      price: "$39.99",
    },
    {
      title: "Birthday Wishes Cupcake Box",
      subtitle: "Delicious cupcakes to make the day extra sweet.",
      image: "./cupcake.svg",
      price: "$29.99",
    },
  ];

  // Combine static items with added links
  const allItems = [...staticWishlistItems, ...addedLinks];

  const occassions = [
      {
      icon: "./cake.png",
      title: "Birthday",
      date: "February 27, 2026",
      itemCount: 5,
    },
    {
      icon: "./graduation.svg",
      title: "Graduation",
      date: "May 14, 2026",
      itemCount: 5,
    },
  ];

  // NEW: Function to scroll to bottom of items container
  const scrollToBottom = () => {
    if (itemsContainerRef.current) {
      // Use setTimeout to ensure DOM has updated
      setTimeout(() => {
        itemsContainerRef.current.scrollTop = itemsContainerRef.current.scrollHeight;
      }, 100);
    }
  };

  // NEW: Effect to scroll when showLinkInput changes or addedLinks changes
  useEffect(() => {
    scrollToBottom();
  }, [showLinkInput, addedLinks]);

  const handleViewList = (occasion) => {
    console.log(`Viewing list for: ${occasion}`);
  };

  // NEW: Function to find matching card for a URL
  const findMatchingCard = (url) => {
  const normalizedUrl = url.toLowerCase().trim();

  for (const pattern of urlPatterns) {
    if (pattern.pattern.test(normalizedUrl)) {
      const matchingCard = availableCards.find(
        card => card.title === pattern.card
      );

      if (matchingCard) {
        return {
          card: matchingCard,
          finalLink: pattern.link, // ✅ ALWAYS use canonical link
        };
      }
    }
  }

  return null;
};


  // NEW: Handle adding external link with URL matching
const handleAddLink = () => {
  if (linkInput.trim() === "" || availableCards.length === 0) return;

  let newCard = null;

  const matched = findMatchingCard(linkInput);

  if (matched) {
    // ✅ Use matched card AND its predefined link
    newCard = {
      ...matched.card,
      link: matched.finalLink,
      matchedFromUserInput: true,
    };
  } else {
    // Fallback → random card with user link
    const randomIndex = Math.floor(Math.random() * availableCards.length);
    const randomCard = availableCards[randomIndex];

    newCard = {
      ...randomCard,
      link: linkInput.trim(),
      matchedFromUserInput: false,
    };
  }

  setAddedLinks(prev => [...prev, newCard]);
  setAvailableCards(prev =>
    prev.filter(card => card.id !== newCard.id)
  );

  setLinkInput("");
  setShowLinkInput(false);
};

// Updated: Function to handle link click on card
const handleCardClick = (item, e) => {
  e.preventDefault();
  e.stopPropagation();

  // ✅ Resolve link strictly from urlPatterns using title
  const resolvedLink = getLinkFromTitle(item.title);

  if (resolvedLink) {
    window.open(resolvedLink, "_blank", "noopener,noreferrer");
  } else {
    console.warn("No matching URL pattern for:", item.title);
  }
};



  // NEW: Handle cancel
  const handleCancelLink = () => {
    setShowLinkInput(false);
    setLinkInput("");
  };

  // NEW: Handle showing the link input
  const handleShowLinkInput = () => {
    if (availableCards.length > 0) {
      setShowLinkInput(true);
    }
  };

  // NEW: Function to handle link click on card
  // const handleCardClick = (item) => {
  //   if (item.actualLink || item.link) {
  //     window.open(item.actualLink || item.link, '_blank');
  //   }
  // };

  const getLinkFromTitle = (title) => {
  const matchedPattern = urlPatterns.find(
    (p) => p.card === title
  );

  return matchedPattern ? matchedPattern.link : null;
};


  const cardStyle = {
    display: "flex",
    width: "100%",
    padding: "16px",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "12px",
    borderRadius: "20px",
    position: "relative",
    color: "#FFF",
    borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
    marginBottom: "5px",
    overflow: "visible",
    cursor: (item) => (item.actualLink || item.link) ? "pointer" : "default",
  };

  return (
    <div
      className="sidebar-scroll"
      style={{
        height: !isMobile ? "82vh" : "90vh",
        maxHeight: "837px",
        background: "rgba(255, 255, 255, 0.20)",
        backdropFilter: "blur(30px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        boxShadow: isOpen ? "-4px 0 30px rgba(0,0,0,0.1)" : "none",
        transition: "all 0.4s ease",
        zIndex: 1000,
        overflow: "hidden",
        padding: "24px",
        borderRadius: isOpen ? "32px" : "0",
        opacity: isOpen ? 1 : 0,
        width : '100%',
        zIndex: 10,
      }}
    >
      {/* Header - EXACTLY THE SAME */}
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "24px",
          flexDirection: !isMobile ? "row" : "column",
          gap: !isMobile ? "" : "24px",
          width: "100%",
        }}
      >
        {/* LEFT SIDE: Title and description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: !isMobile ? "1 0 50%" : "1",
            minWidth: 0,
            maxWidth: !isMobile ? "50%" : "100%",
          }}
        >
          <h2
            style={{
              color: "#fff",
              fontSize: "27px",
              fontWeight: 600,
              marginBottom: 4,
            }}
          >
            Maggie's Wishlist
          </h2>
          <p
            style={{
              color: "#FFF",
              fontFamily: "Manrope",
              fontSize: "15px",
              fontWeight: 400,
            }}
          >
            View your student's wishlist and launch a gift campaign.
          </p>
        </div>

        {/* RIGHT SIDE: Buttons - aligned with the right content */}
        <div
          style={{
            display: "flex",
            gap: "16px",
            justifyContent:  "flex-start",
            flexShrink: 0,
            width: !isMobile ? "50%" : "100%",
            marginLeft:"10px",
            marginTop: !isMobile ? "0" : "8px",
            paddingLeft: !isMobile ? "15px" : "0", // Add padding to align with right content
            boxSizing: "border-box",
          }}
        >
          {/* Create Wishlist */}
          <button
            style={{
              display: "flex",
              padding: "4px 8px",
              alignItems: "center",
              gap: "6px",
              borderRadius: "100px",
              cursor: "pointer",
              background: "#9AAC89",
              color: "#FFF",
              fontFamily: "Manrope",
              fontSize: "15px",
              border: "none",
              height: "32px",
              whiteSpace: "nowrap",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
                fill="#F5F3ED"
              />
              <path
                d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z"
                fill="#F5F3ED"
              />
            </svg>
            Create Wishlist
          </button>

          {/* Start Gift Campaign */}
          <button
            style={{
              display: "flex",
              padding: "4px 10px",
              alignItems: "center",
              gap: "6px",
              borderRadius: "100px",
              cursor: "pointer",
              background: "#9AAC89",
              color: "#FFF",
              fontFamily: "Manrope",
              fontSize: "15px",
              border: "none",
              height: "32px",
              whiteSpace: "nowrap",
            }}
            onClick={() => console.log("Start Gift Campaign clicked")}
          >
            <span
              style={{
                fontSize: "26px",
                lineHeight: "1",
                fontWeight: "100",
              }}
            >
              +
            </span>
            Start Gift Campaign
          </button>
        </div>
      </div>

      {/* Main content - WITH SCROLL */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          overflow: "visible",
          height: "calc(100% - 140px)",
          gap: "24px",
          flexDirection: !isMobile ? "" : "column",
        }}
      >
        {/* LEFT SIDE: Occasions - WITH SCROLL */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            flexDirection: "column",
            alignItems: "flex-start",
            width: !isMobile ? "50%" : "100%",
            height: "100%",
            overflowY: "hidden",
          }}
        >
          {/* Occasion Cards Container WITH SCROLL */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              width: "100%",
              height: "100%",
              overflowY: "auto",
              paddingRight: "4px",
            }}
            className="custom-scroll"
          >
            {occassions.map((item) => (
              <div
                key={item.title}
                style={{
                  display: "flex",
                  width: "100%",
                  padding: "16px",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  gap: "12px",
                  borderRadius: "20px",
                  background: "rgba(255, 255, 255, 0.20)",
                  backdropFilter: "blur(10px)",
                  position: "relative",
                  color: "#FFF",
                  borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                }}
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  style={{ height: "51px", width: "51px", aspectRatio: 1 / 1 }}
                />
                <h1
                  style={{
                    color: "#FFF",
                    fontFamily: "Manrope",
                    fontSize: !isMobile ? "20px" : "15px",
                    fontWeight: 700,
                    letterSpacing: "-0.26px",
                  }}
                >
                  {item.title}
                </h1>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span style={{ fontSize: "12px" }}>{item.date}</span>
                  <span style={{ fontSize: "12px" }}>
                    {item.itemCount} items
                  </span>
                </div>

                {/* View List + Share Section */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "12px",
                  }}
                >
                  <button
                    style={{
                      background:
                        item.title === "Birthday"
                          ? "#FFFFFF"
                          : "rgba(255, 255, 255, 0.25)",
                      color: item.title === "Birthday" ? "#000" : "#FFF",
                      border: "none",
                      borderRadius: "100px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Manrope",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      boxShadow:
                        item.title === "Birthday"
                          ? "0 0 4px rgba(255,255,255,0.3)"
                          : "0 0 4px rgba(0,0,0,0.15)",
                    }}
                    onClick={() => handleViewList(item.title)}
                  >
                    View List
                  </button>

                  <SocialShareButton
                    section="wishlist"
                    card={{ title: item.title }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE: Lists - WITH SCROLL */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            flexDirection: "column",
            alignItems: "flex-start",
            width: !isMobile ? "50%" : "100%",
            height: "100%",
            overflowY: "hidden",
          }}
        >
          <h1
            style={{
              color: "#FFF",
              fontFamily: "Manrope",
              fontSize: "22px",
              fontWeight: 700,
              letterSpacing: "-0.26px",
              marginBottom: "8px",
              marginLeft: "15px",
            }}
          >
            Birthday
          </h1>

          {/* Items Container WITH SCROLL - ADDED REF HERE */}
          <div
            ref={itemsContainerRef}
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: "calc(100% - 40px)",
              overflowY: "auto",
              paddingRight: "4px",
            }}
            className="custom-scroll"
          >
            {/* Display all items (static + added links) */}
            {allItems.map((item, index) => (
              <div
            key={index}
            title="Click to visit product link"
            style={{ cursor: "pointer" }}
            onClick={(e) => handleCardClick(item, e)}
          >

  <div
    style={{
      display: "flex",
      width: "100%",
      padding: "16px",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: "12px",
      borderRadius: "20px",
      position: "relative",
      color: "#FFF",
      borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
      marginBottom: "5px",
      overflow: "visible",
    }}
  >
    {/* Image */}
    <div
      style={{
        width: "60px",
        height: "60px",
        borderRadius: "12px",
        background: `url(${item.image}) lightgray 50% / cover no-repeat`,
        flexShrink: 0,
      }}
    />

    {/* Text */}
    <div
      style={{
        display: "flex",
        flexDirection: !isMobile ? "row" : "column",
        gap: !isMobile ? "12px" : "8px",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "4px",
          flex: "1 0 0",
        }}
      >
        <div
          style={{
            fontSize: "15px",
            fontWeight: 500,
            fontFamily: "Manrope",
          }}
        >
          {item.title}
        </div>

        <div
          style={{
            fontSize: "11px",
            color: "rgba(255,255,255,0.8)",
            fontFamily: "Manrope",
          }}
        >
          {item.subtitle}
        </div>
      </div>

      {/* Price */}
      <div
        style={{
          position: !isMobile ? "absolute" : "static",
          bottom: "16px",
          right: "16px",
          fontSize: "14px",
          fontWeight: 700,
          fontFamily: "Manrope",
        }}
      >
        {item.price}
      </div>
    </div>
  </div>
</div>

            ))}

            {/* NEW: Link Input Box */}
            {showLinkInput && (
              <div
                style={{
                  marginTop: "12px",
                  padding: "16px",
                  borderRadius: "20px",
                  background: "rgba(255, 255, 255, 0.15)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  marginBottom: "12px",
                }}
              >
                <input
                  type="text"
                  value={linkInput}
                  onChange={(e) => setLinkInput(e.target.value)}
                  placeholder="Enter product URL ..."
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    borderRadius: "12px",
                    background: "rgba(255, 255, 255, 0.1)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    color: "#FFF",
                    fontFamily: "Manrope",
                    fontSize: "14px",
                    marginBottom: "12px",
                  }}
                />
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    onClick={handleAddLink}
                    style={{
                      flex: 1,
                      padding: "8px 12px",
                      borderRadius: "12px",
                      background: "#9AAC89",
                      color: "#FFF",
                      border: "none",
                      fontFamily: "Manrope",
                      fontSize: "14px",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                  >
                    Add
                  </button>
                  <button
                    onClick={handleCancelLink}
                    style={{
                      flex: 1,
                      padding: "8px 12px",
                      borderRadius: "12px",
                      background: "rgba(255, 255, 255, 0.1)",
                      color: "#FFF",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      fontFamily: "Manrope",
                      fontSize: "14px",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            {/* NEW: Updated Add external links button */}
            <div
              style={{
                marginTop: "12px",
                textAlign: "right",
                color: availableCards.length === 0 ? "rgba(255, 255, 255, 0.5)" : "#FFF",
                fontFamily: "Manrope",
                fontSize: "14px",
                fontWeight: 500,
                textDecoration: "underline",
                cursor: availableCards.length === 0 ? "default" : "pointer",
                paddingBottom: "8px",
                position: "sticky",
                bottom: "0",
                background: "transparent",
              }}
              onClick={handleShowLinkInput}
            >
              {availableCards.length === 0 
                ? "All wishes added" 
                : `+ Add Wish Item`}
            </div>
          </div>
        </div>
      </div>  
    </div>
  );
};

export default Wishlist;